<template>
    <div>
        <!-- Banner Section -->
        <div class="banner">
            <div class="headerReplacementAnalystInfo"></div>
            <div class="banner-text">
                <b>บทวิเคราะห์หลักทรัพย์</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
                    <span class="separator"></span>
                    <span>ข้อมูลนักวิเคราะห์</span>
                    <span class="separator"></span>
                    <span><b>บทวิเคราะห์หลักทรัพย์</b></span>
                </div>
            </div>
        </div>

        <div class="container mb-5">

            <div class="TabMenu">
                <AnalystInfoTabMenu />
            </div>

            <div class="row g-3 row justify-content-end mb-3">
                <div class="col-auto">
                    <label class="col-form-label">เลือกปี</label>
                </div>
                <div class="col-auto">
                    <select id="yearSelect" v-model="selectedYear" class="form-select" aria-label="Year selection">
                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                    </select>
                </div>
            </div>

            <table class="table mt-3 mb-5">
                <thead>
                    <tr class="table-secondary">
                        <th scope="col"><b>บริษัทหลักทรัพย์</b></th>
                        <th scope="col" class="text-center"><b>วันที่</b></th>
                        <th scope="col" class="text-center"><b>ดาวน์โหลดไฟล์ PDF</b></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="isLoading">
                        <td colspan="3" class="text-center">
                            <div class="d-flex justify-content-center align-items-center" style="height: 100px;">
                                <div class="spinner-grow custom-spinner" role="status"></div>
                            </div>
                        </td>
                    </tr>

                    <tr v-for="(item, index) in filteredList" :key="index">
                        <th scope="row">{{ item.securities_analysis_name }}</th>
                        <td class="text-center">{{ formatDate(item.securities_analysis_date) }}</td>
                        <td class="text-center">
                            <a :href="item.securities_analysis_pdf_url" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import AnalystInfoTabMenu from '@/components/AnalystInfoTabMenu.vue';
import store from "@/store";
import { GET_SECURITIES_ANALYSIS_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        AnalystInfoTabMenu,
    },
    data() {
        return {
            list: [],
            isLoading: false,
            selectedYear: new Date().getFullYear() + 543, // ปี พ.ศ. ปัจจุบัน
            years: Array.from({ length: 2567 - 2558 + 1 }, (_, i) => 2558 + i).reverse(),
            selectedYear: '2567',
        };
    },
    computed: {
        filteredList() {
            return this.list.filter(item => {
                const year = new Date(item.securities_analysis_date).getFullYear() + 543;
                return year === parseInt(this.selectedYear);
            });
        }
    },
    async created() {
        this.isLoading = true;
        await this.init();
        this.isLoading = false;
    },
    methods: {
        async init() {
            this.list = await store.dispatch(GET_SECURITIES_ANALYSIS_DATA);
            console.log(this.list);
        },
        formatDate(dateString) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            const date = new Date(dateString);
            return date.toLocaleDateString('th-TH', options);
        },
    }
};
</script>

<style scoped>
h2.mt-5 {
    display: inline-block;
    border-bottom: 3px solid #E87D2E;
    padding-bottom: 5px;
}

.card-pdf {
    box-shadow: 0px 4px 10px 0px #0000000D;
    border: none;
}

.card {
    background-color: #F2F2F2;
}

.vertical-line {
    width: 4px;
    background-color: #E87D2E;
    margin-left: 30px;
    height: 40%;
    margin-top: 10px;
}

th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}
</style>
